import tw, { styled } from 'twin.macro';

export const ButtonWrapper = styled.span`
  ${tw`relative`};

  a {
    width: fit-content;
  }

  button, a {
    ${tw`flex items-center justify-center whitespace-nowrap rounded overflow-ellipsis px-4 py-3.5 gap-4 bg-white cursor-pointer`};
    font-family: Quicksand !important;
    transition: all .5s ease-in-out;
    border: 0.5px solid #007996;
    letter-spacing: 0.02em;
    font-weight: 500;
    line-height: 1.0;
    color: #007996;

    &.show-chevron-icon span.button-text {
      ${tw`pr-4`};
    }

    span.button-text {
      font-family: Quicksand !important;
      line-height: 16.44px;
    }

    &.wrap-text span.button-text {
      ${tw`whitespace-pre-wrap`};
    }

    .chevron-icon, .close-icon {
      ${tw`p-1`};
  
      img {
        ${tw`w-3 h-3`};
      }
    }

    .chevron-icon {
      ${tw`absolute right-3`};
    }

    &.border-gray:not(:disabled) {
      border: 0.2px solid #a4a3a3;
    }

    &.borderless:not(:disabled) {
      ${tw`border-none`};
    }

    &.text-black:not(:disabled) {
      ${tw`text-black`};
    }

    &.error:not(:disabled) {
      ${tw`text-red-500`};
    }

    :disabled {
      ${tw`text-gray-400 border-gray-400 cursor-not-allowed bg-gray-100`};
    }

    &.block {
      ${tw`w-full`};
    }

    &.text-left {
      ${tw`justify-start`};
    }

    &.icon:not(:disabled) {
      ${tw`p-0 w-10 h-10 border-none`};
      
      img {
        ${tw`w-full h-full`};
      }
    }

    &.secondary {
      color: rgba(26, 140, 175, 1) !important;
  
      &:hover {
        ${tw`border-transparent shadow-none`};
        background-color: aliceblue;
      }
    }
  
    &.primary {
      background: linear-gradient(to left top, rgba(0, 175, 191, 1), rgba(26, 140, 175, 1));
      background-color: rgba(26, 140, 175, 1);
      color: white !important;
  
      &:hover {
        background: linear-gradient(to left top, #066f8f, rgba(26, 140, 175, 1));
        border-color: rgba(26, 140, 175, 0.1);
      }
    }
  
    &.success {
      background-color: #28a745;
      border-color: #28a745;
      ${tw`text-white`};
      font-weight: 400;
      
      &:hover {
        background-color: #218838;
        border-color: #1e7e34;
      }
    }

    &.link:not(:disabled) {
      ${tw`p-0 no-underline border-none gap-2`};
      line-height: 16.44px;
      white-space: unset;
      font-weight: 500;
      font-size: 13px;
      color: #00a0c6;

      img {
        ${tw`w-3`};
      }
    }

    &.filled:not(:disabled) {
      ${tw`text-white border-none`};
      background-color: #00a0c6;
    }

    &.grayed:not(:disabled) {
      ${tw`bg-gray-100 text-black border-none`};
    }

    &.text:not(:disabled) {
      ${tw`p-0 border-none bg-transparent`};
      line-height: 15.18px;
      font-weight: 450;
      font-size: 12px;
      color: #4f4f4f;
    }

    img {
      ${tw`w-5 h-5`};
    }
    
    &.shadow {
      box-shadow: rgba(23, 28, 33, .15) 0px 2px 6px 0;
    }

    &.medium {
      font-size: 14px;
    }

    &.large {
      font-size: 1.25rem;
      ${tw`h-14 px-8`};
      line-height: 1.5;
    }

    &.small {
      font-size: 13px;
      ${tw`h-8`};
    }
  }

  &:hover .tooltip {
    display: block;
  }
`;

export const InformationDiv = styled.div`
  ${tw`bg-white absolute p-4 text-center`}
  width: 220px;
  box-shadow: 0px 4px 25px rgba(196, 196, 196, 0.25);
  border-radius: 2px;
  border: 0.2px solid #0095ba;
  display: none;
  left: ${({ position }) => position === 'right' && '35px'};
  right: ${({ position }) => position === 'left' && '35px'};
  top: -10px;
  &:before {
    content: ' ';
    position: absolute;
    top: 10px;
    left: ${({ position }) => position === 'left' && '100%'};
    right: ${({ position }) => position === 'right' && '100%'};
    margin-top: 0px;
    border-width: 10px;
    border-style: solid;
    border-color: ${({ position }) =>
      position === 'left'
        ? 'transparent transparent transparent #0095ba'
        : 'transparent #0095ba transparent transparent'};
  }
  &:after {
    content: ' ';
    position: absolute;
    top: 11px;
    left: ${({ position }) => position === 'left' && '100%'};
    right: ${({ position }) => position === 'right' && '100%'};
    margin-top: 0px;
    border-width: 9px;
    border-style: solid;
    border-color: ${({ position }) =>
      position === 'left' ? 'transparent transparent transparent white' : 'transparent white transparent transparent'};
  }
`;